import { get } from '../../../utils/api';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  getCatalogGoods: params => get({ url: 'catalog/goods', data: params }),
  getCatalogUpsale: params => get({ url: 'catalog/upsale', data: withUnauthorizedToken(params) }),
  getCatalogActiveIngredients: () => get({ url: 'catalog/active-ingredients' }),
  getCatalogNotFoundSlider: () => get({ url: 'catalog/recommend-goods' }),
};
